//is loggedin
export const isLoggedIn = () => {
  //let data = localStorage.getItem("data");
  const data = localStorage.getItem("loginData");
  if (data == null) {
    return false;
  } else {
    return true;
  }
};
//doLogin=>data=>set to localStorage
export const doLogin = (data, next) => {
  localStorage.setItem("loginData", JSON.stringify(data));

  next();
};
//do logout=>remove from localstorage
export const doLogout = () => {
  localStorage.removeItem("loginData");
};

//get currentuser
export const getCurrentUserDetail = () => {
  if (isLoggedIn()) {
    return JSON.parse(localStorage.getItem("loginData"));
  } else {
    return undefined;
  }
};
